async function getIp (){
    var response = await $.getJSON('https://api.ipify.org?format=json', function() {});
    return response.ip;
}
async function getLatLon (){
  var ip = await getIp();
    var response = await $.getJSON('https://ipapi.co/'+ ip + '/json/', function() {});
      var result = {lat: response.latitude , long: response.longitude, city: response.city};
    return result;
}    

window.setLocationCity = function(data){
  var target = ".location-search input";
  $(target).val(data);
}

window.addEventListener('load', function() {
var map = new google.maps.Map(document.getElementById('map-canvas'), {
center: new google.maps.LatLng(-28, 135),
zoom: 4,
mapTypeId: google.maps.MapTypeId.ROADMAP,
styles:[
    {
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#f5f5f5"
        }
      ]
    },
    {
      "elementType": "labels.icon",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#616161"
        }
      ]
    },
    {
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#f5f5f5"
        }
      ]
    },
    {
      "featureType": "administrative.land_parcel",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "administrative.land_parcel",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#bdbdbd"
        }
      ]
    },
    {
      "featureType": "administrative.neighborhood",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#eeeeee"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.text",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#757575"
        }
      ]
    },
    {
      "featureType": "poi.business",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#e5e5e5"
        }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#9e9e9e"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#ffffff"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "labels.icon",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road.arterial",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road.arterial",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#757575"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#dadada"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "labels",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#616161"
        }
      ]
    },
    {
      "featureType": "road.local",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "road.local",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#9e9e9e"
        }
      ]
    },
    {
      "featureType": "transit",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "transit.line",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#e5e5e5"
        }
      ]
    },
    {
      "featureType": "transit.station",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#eeeeee"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#c9c9c9"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "labels.text",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#9e9e9e"
        }
      ]
    }
  ]
});
if(document.getElementById('store-locator')) {
  let pos = {lat: -28, lng: 135}
  if (navigator.geolocation) {
    
    navigator.geolocation.getCurrentPosition((position) => {
      pos = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
      map.setCenter(pos)
      map.setZoom(11)
    }
    );
  }
}

var panelDiv = document.getElementById('panel');

var data = new StoreDataSource;


if(window.location.href.indexOf("stores") > -1){
var view = new storeLocator.View(map, data, {
  geolocation: true,
  features: data.getFeatures(),
  markerIcon: "//spotters.com.au/cdn/shop/files/marker.png?v=1787127807"
});
} else {
var view = new storeLocator.View(map, data, {
  geolocation: false,
  features: data.getFeatures(),
  markerIcon: "//spotters.com.au/cdn/shop/files/marker.png?v=1787127807"
});
}


var mainPanel = new storeLocator.Panel(panelDiv, {
view: view,
locationSearchLabel: ''
});

view.addListener('selectedStore_changed',function(){
var target = "#panel";
if($(target).hasClass('list-shown')){
  $('#panel').removeClass('list-shown');
  $('#panel .btn').text('list');
}

})
view.addListener('geolocate',function(){

})
});


/**
* @extends storeLocator.StaticDataFeed
* @constructor
*/
function StoreDataSource() {
$.extend(this, new storeLocator.StaticDataFeed);
var that = this;
$.get('https://sheets.googleapis.com/v4/spreadsheets/1563KPHcl3-n_xWLPBP5VIXUf2BPJx04OyTTEVMGuzPQ/values:batchGet?ranges=A1:Z10000&key=AIzaSyCHDtrvbqer-5m6QwwNVs8YbQ_YwAPFyZ8', function(data) {
var csv = '';  
for (i = 0; i < data.valueRanges['0'].values.length; i++) { 
  var cellData = [];
  for (x = 0; x < data.valueRanges['0'].values[i].length; x++) {
    // Replace commas with semicolons to avoid CSV parsing issues
    var cellValue = data.valueRanges['0'].values[i][x];
    if (cellValue) {
      cellData[x] = '"' + cellValue.replace(/"/g, '""').replace(',', ';') + '"';
    } else {
      cellData[x] = '""';
    }
  }
  csv += cellData.join(',') + '\n';
}
console.log(that.parse_(csv))
that.setStores(that.parse_(csv));

});
}

/**
* @const
* @type {!storeLocator.FeatureSet}
* @private
*/
StoreDataSource.prototype.FEATURES_ = new storeLocator.FeatureSet(
  new storeLocator.Feature('Sunglasses-TRUE', 'Sunglasses'),
  new storeLocator.Feature('Kids Sunglasses-TRUE', 'Kids Sunglasses'),
  new storeLocator.Feature('Prescriptions-TRUE', 'Prescriptions')
);

/**
* @return {!storeLocator.FeatureSet}
*/
StoreDataSource.prototype.getFeatures = function() {
return this.FEATURES_;
};

/**
* @private
* @param {string} csv
* @return {!Array.<!storeLocator.Store>}
*/
StoreDataSource.prototype.parse_ = function(csv) {
var stores = [];
var rows = csv.split('\n');
var headings = this.parseRow_(rows[0]);

for (var i = 1; i < rows.length; i++) {
  if (!rows[i].trim()) continue; // Skip empty rows
  
  var rowData = this.parseRow_(rows[i]);
  var singleObject = {};
  
  for (var x = 0; x < headings.length && x < rowData.length; x++) {
    if (rowData[x] != null && rowData[x] !== '') {
      // Convert semicolons back to commas and remove quotes
      var cleanValue = rowData[x].replace(/^"|"$/g, '').replace(/""/g, '"').replace(';', ',');
      var cleanHeader = headings[x].replace(/(\r\n|\n|\r)/gm, "");
      singleObject[cleanHeader] = cleanValue;
    }
  }
    
  var position = new google.maps.LatLng(singleObject.Latitude,singleObject.Longitude);
  var street = this.join_([singleObject.Shop_Number, singleObject.Shop_Street],' ');
  var shop = this.join_([street , singleObject.Shop_City], ', ');
  var locality = this.join_([singleObject.Shop_State, singleObject.Shop_Postcode], ', ');

  var features = new storeLocator.FeatureSet;
  features.add(this.FEATURES_.getById('<a class="store-callus" href="tel:'+ singleObject.Phone_Number +'" onclick="clickCallStore(\''+ singleObject.Shop_Name +'\')"><button class="btn btn mb-2 w-100 btn-secondary dark darkOnWhite w-100">Call us</button></a>'));
  features.add(this.FEATURES_.getById('<a class="store-directions"  onclick="clickDirectionsStore(\''+ singleObject.Shop_Name +'\')" href="https://www.google.com/maps/search/?api=1&query='+ shop.split(' ').join('+') + ',' + locality.split(' ').join('+') +'" onclick="clickDirectionStore(\''+ singleObject.Shop_Name +'\')" target="_blank"><button class="btn btn-secondary dark w-100 darkOnWhite my-2">Directions</button></a>'));
  features.add(this.FEATURES_.getById('Sunglasses-' + singleObject['Sunglasses']));
  features.add(this.FEATURES_.getById('Kids Sunglasses-' + singleObject['Kids Sunglasses']));
  features.add(this.FEATURES_.getById('Prescriptions-' + singleObject['Prescriptions']));
    

  if (singleObject.Phone_Number == null){
    var isTelHidden = 'd-none';
  } else {
    var isTelHidden = '';
  }
  
  var store = new storeLocator.Store(i, position, features, {
    title: singleObject.Shop_Name,
    address: this.join_([shop, locality], ' '),
    phone: '<a href="tel:'+ singleObject.Phone_Number +'" onclick="clickCallStore(\''+ singleObject.Shop_Name +'\')" class="'+ isTelHidden +'">' + singleObject.Phone_Number + '</a>'
  });
  
  if(singleObject.Shop_Name){
    stores.push(store);
  }
}

return stores;

};
/**
* Joins elements of an array that are non-empty and non-null.
* @private
* @param {!Array} arr array of elements to join.
* @param {string} sep the separator.
* @return {string}
*/
StoreDataSource.prototype.join_ = function(arr, sep) {
var parts = [];
for (var i = 0, ii = arr.length; i < ii; i++) {
  arr[i] && parts.push(arr[i]);
}
return parts.join(sep);
};

/**
* Very rudimentary CSV parsing - we know how this particular CSV is formatted.
* IMPORTANT: Don't use this for general CSV parsing!
* @private
* @param {string} row
* @return {Array.<string>}
*/
StoreDataSource.prototype.parseRow_ = function(row) {
// Handle properly formatted CSV with quoted fields
if (row.trim() === '') {
  return [];
}

// Parse CSV row with quoted fields
var fields = [];
var currentField = '';
var inQuotes = false;
var escapeNext = false;

for (var i = 0; i < row.length; i++) {
  var char = row[i];
  
  if (escapeNext) {
    currentField += char;
    escapeNext = false;
    continue;
  }
  
  if (char === '"') {
    if (inQuotes) {
      // Check if this is an escaped quote
      if (i + 1 < row.length && row[i + 1] === '"') {
        currentField += '"';
        escapeNext = true;
      } else {
        inQuotes = false;
      }
    } else {
      inQuotes = true;
    }
  } else if (char === ',' && !inQuotes) {
    fields.push(currentField.trim());
    currentField = '';
  } else {
    currentField += char;
  }
}

// Add the last field
fields.push(currentField.trim());

return fields;
};

/**
* Creates an object mapping headings to row elements.
* @private
* @param {Array.<string>} headings
* @param {Array.<string>} row
* @return {Object}
*/
StoreDataSource.prototype.toObject_ = function(headings, row) {
var result = {};
for (var i = 0, ii = row.length; i < ii; i++) {
  result[headings[i]] = row[i];
}
return result;
};